(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7190],{

/***/ 91291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ loadStripe; }
/* harmony export */ });
var V3_URL = 'https://js.stripe.com/v3';
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var findScript = function findScript() {
  var scripts = document.querySelectorAll("script[src^=\"".concat(V3_URL, "\"]"));

  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];

    if (!V3_URL_REGEX.test(script.src)) {
      continue;
    }

    return script;
  }

  return null;
};

var injectScript = function injectScript(params) {
  var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
  var script = document.createElement('script');
  script.src = "".concat(V3_URL).concat(queryString);
  var headOrBody = document.head || document.body;

  if (!headOrBody) {
    throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
  }

  headOrBody.appendChild(script);
  return script;
};

var registerWrapper = function registerWrapper(stripe, startTime) {
  if (!stripe || !stripe._registerWrapper) {
    return;
  }

  stripe._registerWrapper({
    name: 'stripe-js',
    version: "2.4.0",
    startTime: startTime
  });
};

var stripePromise = null;
var onErrorListener = null;
var onLoadListener = null;

var onError = function onError(reject) {
  return function () {
    reject(new Error('Failed to load Stripe.js'));
  };
};

var onLoad = function onLoad(resolve, reject) {
  return function () {
    if (window.Stripe) {
      resolve(window.Stripe);
    } else {
      reject(new Error('Stripe.js not available'));
    }
  };
};

var loadScript = function loadScript(params) {
  // Ensure that we only attempt to load Stripe.js at most once
  if (stripePromise !== null) {
    return stripePromise;
  }

  stripePromise = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      // Resolve to null when imported server side. This makes the module
      // safe to import in an isomorphic code base.
      resolve(null);
      return;
    }

    if (window.Stripe && params) {
      console.warn(EXISTING_SCRIPT_MESSAGE);
    }

    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }

    try {
      var script = findScript();

      if (script && params) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
      } else if (!script) {
        script = injectScript(params);
      } else if (script && onLoadListener !== null && onErrorListener !== null) {
        var _script$parentNode;

        // remove event listeners
        script.removeEventListener('load', onLoadListener);
        script.removeEventListener('error', onErrorListener); // if script exists, but we are reloading due to an error,
        // reload script to trigger 'load' event

        (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 ? void 0 : _script$parentNode.removeChild(script);
        script = injectScript(params);
      }

      onLoadListener = onLoad(resolve, reject);
      onErrorListener = onError(reject);
      script.addEventListener('load', onLoadListener);
      script.addEventListener('error', onErrorListener);
    } catch (error) {
      reject(error);
      return;
    }
  }); // Resets stripePromise on error

  return stripePromise["catch"](function (error) {
    stripePromise = null;
    return Promise.reject(error);
  });
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
  if (maybeStripe === null) {
    return null;
  }

  var stripe = maybeStripe.apply(undefined, args);
  registerWrapper(stripe, startTime);
  return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

var stripePromise$1;
var loadCalled = false;

var getStripePromise = function getStripePromise() {
  if (stripePromise$1) {
    return stripePromise$1;
  }

  stripePromise$1 = loadScript(null)["catch"](function (error) {
    // clear cache on error
    stripePromise$1 = null;
    return Promise.reject(error);
  });
  return stripePromise$1;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.


Promise.resolve().then(function () {
  return getStripePromise();
})["catch"](function (error) {
  if (!loadCalled) {
    console.warn(error);
  }
});
var loadStripe = function loadStripe() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  loadCalled = true;
  var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script

  return getStripePromise().then(function (maybeStripe) {
    return initStripe(maybeStripe, args, startTime);
  });
};




/***/ }),

/***/ 27945:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[eventId]/register",
      function () {
        return __webpack_require__(52031);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85026:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ Tab; },
/* harmony export */   "m": function() { return /* binding */ Tabs; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51773);


const Tab = (param)=>{
    let { children , title  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
const Tabs = (param)=>{
    let { activeTitle , children , stickyHeader =false , className  } = param;
    const activeTab = children.filter((c)=>c !== false).find((c)=>c.props.title === activeTitle);
    if (className) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_1__["default"], {
        className: className,
        children: activeTab
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: activeTab
    });
};


/***/ }),

/***/ 95746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ GET_EVENT_BY_DONATION_URL; }
/* harmony export */ });
/* harmony import */ var _graphql_generated__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66703);

const GET_EVENT_BY_DONATION_URL = (0,_graphql_generated__WEBPACK_IMPORTED_MODULE_0__/* .graphql */ .B)("\n  query getEventByDonationUrl($input: GetEventByDonationUrlInput!) {\n    getEventByDonationUrl(input: $input) {\n      ...EventData\n      __typename\n      fundraising {\n        id\n        title\n        description\n        goal\n        feeAbsorption\n        programs {\n          title\n          description\n          goal\n          media {\n            title\n            body\n            platform\n            url\n          }\n          active\n          enabled\n        }\n        media {\n          title\n          body\n          platform\n          url\n        }\n        transactions {\n          selectedProgram\n          fee\n          total\n          email\n          amount\n          created\n          currency\n          coverFee\n          address\n          giftAid\n          firstName\n          lastName\n          donation\n        }\n      }\n    }\n  }\n\n  fragment EventData on Event {\n    eventId\n    isPublished\n    organizerId\n    event {\n      bannerImage\n      description\n      eventMainColour\n      eventBackgroundColour\n      eventTextColour\n      endDateTime\n      registrationCloseDateTime\n      shortDescription\n      startDateTime\n      title\n      organizationName\n      thumbnailImage\n      publiclyListed\n      currency\n      fixedAdminFee\n      eventType\n      eventLocation\n      donationUrl\n    }\n    donations {\n      email\n      fullName\n      amount\n      message\n      created\n      currency\n      avatarUrl\n      selectedProgram\n    }\n  }\n");


/***/ }),

/***/ 52031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ EventRegister; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/inputs/Button.tsx
var Button = __webpack_require__(11390);
// EXTERNAL MODULE: ./components/base/LoadingSpinner.tsx + 1 modules
var LoadingSpinner = __webpack_require__(38999);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./layouts/Wrapper.tsx + 9 modules
var Wrapper = __webpack_require__(44066);
// EXTERNAL MODULE: ./components/base/Box.tsx
var Box = __webpack_require__(51773);
// EXTERNAL MODULE: ./components/inputs/TextInput.tsx
var TextInput = __webpack_require__(39618);
// EXTERNAL MODULE: ./components/inputs/Form.tsx
var Form = __webpack_require__(26291);
// EXTERNAL MODULE: ./components/base/Tabs.tsx
var Tabs = __webpack_require__(85026);
// EXTERNAL MODULE: ./components/inputs/CountInput.tsx
var CountInput = __webpack_require__(87653);
// EXTERNAL MODULE: ./components/inputs/CheckboxInput.tsx
var CheckboxInput = __webpack_require__(98805);
// EXTERNAL MODULE: ./libs/Utility/register.util.ts
var register_util = __webpack_require__(49981);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/react-icons/fc/index.esm.js
var fc_index_esm = __webpack_require__(81872);
// EXTERNAL MODULE: ./components/inputs/TicketDropdownInput.tsx
var TicketDropdownInput = __webpack_require__(59832);
// EXTERNAL MODULE: ./components/event/register/AdditionalAttendeesStep.tsx
var AdditionalAttendeesStep = __webpack_require__(45289);
// EXTERNAL MODULE: ./components/base/TextLink.tsx
var TextLink = __webpack_require__(82316);
// EXTERNAL MODULE: ./libs/Utility/util.ts + 3 modules
var util = __webpack_require__(53510);
// EXTERNAL MODULE: ./public/images/default-thumbnail.png
var default_thumbnail = __webpack_require__(96963);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/event/register/EventRegistrationHero.tsx






const EventRegistrationHero = (param)=>{
    let { event , dynamicStyle , eventImage , isDarkTheme , videoUrl  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        color: "foregroundColour",
        style: dynamicStyle,
        className: "relative px-2 pt-9 pb-9 border-b border-forumm-menu-border",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                autoPlay: true,
                loop: true,
                muted: true,
                playsInline: true,
                className: "absolute inset-0 w-full h-full object-cover select-none no-controls",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                    src: videoUrl,
                    type: "video/mp4"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "flex flex-col md:flex-row items-center justify-center space-y-6 md:space-y-0",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "rounded-2xl shadow-lg flex p-10 md:p-6 md:py-4 md:pt-6 md:pb-6 w-full md:w-[85%] max-w-[1500px] ".concat(isDarkTheme ? "" : "border border-forumm-menu-border"),
                    color: "backgroundColorBanner",
                    style: {
                        background: isDarkTheme ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.6)",
                        backdropFilter: "blur(5px)",
                        WebkitBackdropFilter: "blur(5px)"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "hidden md:flex flex ml-2 items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "md:h-[250px] md:w-[250px] w-[250px] h-[240px] md:rounded-2xl rounded-md overflow-hidden flex flex-col justify-start items-center mx-auto md:ml-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "h-full w-full bg-cover bg-center",
                                    style: {
                                        backgroundImage: "url('".concat(eventImage, "')")
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "md:w-full ml-2 md:ml-20 md:mr-10 ml-0 flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "flex flex-row items-center mb-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                alt: "Thumbnail Image",
                                                className: "h-10 w-10 rounded-full mr-4 object-cover",
                                                width: 30,
                                                height: 30,
                                                src: (ref6 = event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.thumbnailImage) !== null && ref6 !== void 0 ? ref6 : default_thumbnail/* default */.Z
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "flex items-center text-[14px]",
                                                children: event === null || event === void 0 ? void 0 : (ref1 = event.event) === null || ref1 === void 0 ? void 0 : ref1.organizationName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "text-[36px] w-full font-bold",
                                        children: event === null || event === void 0 ? void 0 : (ref2 = event.event) === null || ref2 === void 0 ? void 0 : ref2.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                        className: "mb-6",
                                        style: {
                                            whiteSpace: "pre-wrap"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* default */.Z, {
                                            className: "text-[16px] md:text-[16px] mt-4 mb-4",
                                            children: event === null || event === void 0 ? void 0 : (ref3 = event.event) === null || ref3 === void 0 ? void 0 : ref3.shortDescription
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "flex mb-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                className: "flex flex-col space-y-2 mr-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "text-md font-medium",
                                                        children: "Start Time/Date"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "text-xs md:text-sm",
                                                        children: (0,util/* formatEventDateTime */.ep)(event === null || event === void 0 ? void 0 : (ref4 = event.event) === null || ref4 === void 0 ? void 0 : ref4.startDateTime, "MMM DD, h:mm A", event === null || event === void 0 ? void 0 : event.event)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                className: "flex flex-col space-y-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "text-md font-medium",
                                                        children: "End Time/Date"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                        className: "text-xs md:text-sm",
                                                        children: (0,util/* formatEventDateTime */.ep)(event === null || event === void 0 ? void 0 : (ref5 = event.event) === null || ref5 === void 0 ? void 0 : ref5.endDateTime, "MMM DD, h:mm A", event === null || event === void 0 ? void 0 : event.event)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "mt-4 text-xs md:text-sm",
                                        children: [
                                            "Having trouble? Email",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "underline",
                                                href: "mailto:hello@forumm.to",
                                                children: "hello@forumm.to"
                                            }),
                                            "."
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var register_EventRegistrationHero = (EventRegistrationHero);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 183 modules
var motion = __webpack_require__(12451);
;// CONCATENATED MODULE: ./components/event/register/EventRegistrationSummary.tsx









const getSocialIcon = (platform)=>{
    if (platform.toLowerCase() === "facebook") return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaFacebook */.Am9, {
        className: "h-8 w-8 my-1 mr-2 cursor-pointer"
    });
    if (platform.toLowerCase() === "twitter") return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaTwitter */.fWC, {
        className: "h-8 w-8 my-1 mr-2 cursor-pointer"
    });
    if (platform.toLowerCase() === "instagram") return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaInstagram */.Zf_, {
        className: "h-8 w-8 my-1 mr-2 cursor-pointer"
    });
    if (platform.toLowerCase() === "linkedin") return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaLinkedin */.ltd, {
        className: "h-8 w-8 my-1 mr-2 cursor-pointer"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaFacebook */.Am9, {
        className: "h-8 w-8 my-1 mr-2 cursor-pointer"
    });
};
const EventRegistrationSummary = (param)=>{
    let { event , foundTicket , isInvoiceTicket , invoiceTicketTotal , currencySymbol , ticketTotalPrice , vatIncluded  } = param;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "w-full sm:w-1/2 px-6 flex flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "text-3xl font-bold",
                children: event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex items-center space-x-2 mt-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        alt: "Thumbnail Image",
                        className: "h-8 w-8 rounded-lg block object-cover",
                        width: 96,
                        height: 96,
                        src: (ref10 = event === null || event === void 0 ? void 0 : (ref1 = event.event) === null || ref1 === void 0 ? void 0 : ref1.thumbnailImage) !== null && ref10 !== void 0 ? ref10 : default_thumbnail/* default */.Z
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "text-lg",
                        children: event === null || event === void 0 ? void 0 : (ref2 = event.event) === null || ref2 === void 0 ? void 0 : ref2.organizationName
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "mt-4 line-clamp-8 text-sm",
                children: event === null || event === void 0 ? void 0 : (ref3 = event.event) === null || ref3 === void 0 ? void 0 : ref3.shortDescription
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                show: !!(event === null || event === void 0 ? void 0 : (ref4 = event.event) === null || ref4 === void 0 ? void 0 : ref4.eventLocation),
                className: "flex flex-col space-y-2 mt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                    className: "w-full flex flex-col space-y-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "text-md font-medium",
                            children: "Event Location"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            className: "text-xs md:text-sm",
                            style: {
                                wordWrap: "break-word"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextLink/* default */.Z, {
                                children: (event === null || event === void 0 ? void 0 : (ref5 = event.event) === null || ref5 === void 0 ? void 0 : ref5.eventLocation) || ""
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "flex my-4 space-x-6 mt-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "flex items-center justify-start text-white mt-6 flex-wrap",
                    children: event === null || event === void 0 ? void 0 : (ref6 = event.communications) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.socials) === null || ref7 === void 0 ? void 0 : ref7.map((social)=>{
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
                            whileHover: {
                                scale: 1
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: social.url,
                                target: "_blank",
                                "data-testid": "social-facebook",
                                children: getSocialIcon(social.platform)
                            })
                        }, social.platform);
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex my-4 space-x-6 mt-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: " flex flex-col space-y-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-md font-medium",
                                children: "Start Date & Time"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-xs md:text-sm",
                                children: (0,util/* formatEventDateTime */.ep)(event === null || event === void 0 ? void 0 : (ref8 = event.event) === null || ref8 === void 0 ? void 0 : ref8.startDateTime, "MMM DD, h:mmA", event === null || event === void 0 ? void 0 : event.event)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                        className: "flex flex-col space-y-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-md font-medium",
                                children: "End Date & Time"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                className: "text-xs md:text-sm",
                                children: (0,util/* formatEventDateTime */.ep)(event === null || event === void 0 ? void 0 : (ref9 = event.event) === null || ref9 === void 0 ? void 0 : ref9.endDateTime, "MMM DD, h:mmA", event === null || event === void 0 ? void 0 : event.event)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                className: "flex text-right flex-col mt-10",
                show: foundTicket != null,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "text-xl",
                        children: "Ticket Cost"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "text-2xl",
                        children: isInvoiceTicket || (foundTicket === null || foundTicket === void 0 ? void 0 : foundTicket.price) === 0 ? isInvoiceTicket ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                    className: "text-xs mr-2 text-gray-400 inline",
                                    children: "Invoiced after registration."
                                }),
                                "".concat(currencySymbol).concat(invoiceTicketTotal.toFixed(2))
                            ]
                        }) : "FREE" : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                    className: "text-xs mr-2 text-gray-400 inline",
                                    children: [
                                        "Price",
                                        vatIncluded ? " includes " : " does not include ",
                                        "tax."
                                    ]
                                }),
                                "".concat(currencySymbol).concat(ticketTotalPrice === null || ticketTotalPrice === void 0 ? void 0 : ticketTotalPrice.toFixed(2)),
                                " "
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var register_EventRegistrationSummary = (EventRegistrationSummary);

// EXTERNAL MODULE: ./components/event/register/RegistrationFieldsStep.tsx
var RegistrationFieldsStep = __webpack_require__(81247);
// EXTERNAL MODULE: ./components/event/register/RegistrationAccountFields.tsx
var RegistrationAccountFields = __webpack_require__(32277);
// EXTERNAL MODULE: ./components/event/register/useEventRegistration.tsx + 4 modules
var useEventRegistration = __webpack_require__(33959);
;// CONCATENATED MODULE: ./pages/event/[eventId]/register.tsx





















var __N_SSP = true;
function EventRegister() {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    const { accountError , activeAdditionalTickets , allTicketsRegistrationFieldsAreFilled , alreadyJoined , attendeesError , attendeesToGetRegFields , availableTickets , clearForm , confirmPassword , continueFromAccountStep , continueFromTicketStep , currency , disableFormProgress , donationData , dynamicStyle , email , error , errorHandler , errors , event , eventId , eventImage , fieldVals , firstName , foundTicket , getEmail , handleAdditionalAttendeesContinue , handleAdditionalTicketChange , handleAdditionalTickets , handleEmailChange , handleGoogleSignIn , handleLinkedInSignIn , handleRegistrationFieldChange , handleRegistrationFieldNext , handleRegistrationFieldPrevious , handleRegistrationFieldsContinue , hasAccount , invoiceTicketTotal , isDarkTheme , isInvoiceTicket , isNewLogin , isRegistrationVisible , lastName , loading , password , profile , regFieldSelectedAttendee , router , saving , selectedTicketAllowsMultiple , setAttendeesError , setConfirmPassword , setErrors , setFirstName , setHasAccount , setIsNewLogin , setIsRegistrationVisible , setLastName , setPassword , setRedirectTarget , setRegFieldSelectedAttendee , setRequiresAdditionalTickets , setTab , setTicketData , signedIn , tab , theme , ticketData , userData , vatIncluded , videoUrl  } = (0,useEventRegistration/* useEventRegistration */.l)();
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
            className: "w-full py-64 flex justify-center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                size: "large"
            })
        });
    }
    var ref7, ref8, ref9, ref10, ref11, ref12;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
        className: "overflow-x-hidden h-full -mt-[80px] pt-[80px] relative event-register-root",
        id: "event-register-root",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(register_EventRegistrationHero, {
                event: event,
                dynamicStyle: dynamicStyle,
                eventImage: eventImage,
                isDarkTheme: isDarkTheme,
                videoUrl: videoUrl
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                className: "w-full flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                    className: "w-full md:w-[85%] max-w-[1500px]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                        className: "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                            id: "donation-box",
                            color: "foregroundColour",
                            className: "mt-8 sm:my-8 rounded-2xl flex flex-col sm:flex-row text-white pt-8 px-2 sm:py-8 min-h-[400px] mb-6 border border-forumm-menu-border",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                className: "w-full flex flex-col sm:flex-row",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                        className: "w-full sm:w-1/2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tabs */.m, {
                                                activeTitle: tab,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                                                        title: "Account",
                                                        children: signedIn || profile ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                            className: "flex flex-col items-center text-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                    className: "mb-2 text-2xl",
                                                                    children: "You're signed in"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                    className: "mb-6 text-sm",
                                                                    children: "Continue to choose your ticket details."
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                    title: "Continue",
                                                                    className: "w-full",
                                                                    onClick: ()=>setTab("Register")
                                                                })
                                                            ]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                    className: "flex mb-2 justify-center items-center text-2xl",
                                                                    children: hasAccount ? "Sign in with your account" : "Create your account"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                    show: !hasAccount && !isNewLogin,
                                                                    className: "flex mb-2 justify-center items-center text-center",
                                                                    children: [
                                                                        "We promise it",
                                                                        "'",
                                                                        "s painless! By adding a password you",
                                                                        "'",
                                                                        "ll have full access to all events hosted on Forumm."
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
                                                                    initialFormData: {
                                                                        firstName: firstName !== null && firstName !== void 0 ? firstName : "",
                                                                        lastName: lastName !== null && lastName !== void 0 ? lastName : "",
                                                                        email: (ref7 = email !== null && email !== void 0 ? email : userData) !== null && ref7 !== void 0 ? ref7 : "",
                                                                        password: password !== null && password !== void 0 ? password : "",
                                                                        confirmPassword: confirmPassword !== null && confirmPassword !== void 0 ? confirmPassword : ""
                                                                    },
                                                                    clearForm: clearForm,
                                                                    onSubmit: (accountData)=>continueFromAccountStep({
                                                                            accountData,
                                                                            onSignedIn: ()=>{
                                                                                window.location.href = "/event/".concat(router.query.eventId, "/register");
                                                                            },
                                                                            validatePasswordConfirmation: !hasAccount
                                                                        }),
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                            className: "mt-6 mb-1",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                                    className: "mb-4 grid grid-cols-2 gap-3",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                                            type: "button",
                                                                                            onClick: handleGoogleSignIn,
                                                                                            className: "flex h-9 items-center justify-center gap-2 rounded border border-slate-400 bg-white px-3 text-xs font-medium text-slate-800 transition-colors hover:bg-slate-50 cursor-pointer",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(fc_index_esm/* FcGoogle */.JM8, {
                                                                                                    className: "h-4 w-4"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    children: "Google"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                                                            type: "button",
                                                                                            onClick: handleLinkedInSignIn,
                                                                                            className: "flex h-9 items-center justify-center gap-2 rounded border border-slate-400 bg-white px-3 text-xs font-medium text-slate-800 transition-colors hover:bg-slate-50 cursor-pointer",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaLinkedinIn */.BUd, {
                                                                                                    className: "h-4 w-4 text-[#0A66C2]"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    children: "LinkedIn"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                                    show: !hasAccount,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                                        type: "button",
                                                                                        onClick: ()=>{
                                                                                            setErrors([]);
                                                                                            setIsNewLogin(true);
                                                                                            setHasAccount(true);
                                                                                        },
                                                                                        className: "mt-3 flex h-9 w-full items-center justify-center rounded border border-slate-400 bg-white px-3 text-xs font-medium text-slate-800 transition-colors hover:bg-slate-50 cursor-pointer",
                                                                                        children: "Log in with email"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                                    className: "mt-6 flex items-center gap-3 text-xs text-gray-500",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                                            className: "h-px flex-1 bg-gray-300"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            children: "Or Register"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                                            className: "h-px flex-1 bg-gray-300"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        (0,RegistrationAccountFields/* default */.Z)({
                                                                            errors,
                                                                            errorHandler,
                                                                            hasAccount,
                                                                            labelBgColour: theme.foregroundColour,
                                                                            nameInputClassName: "w-[49%] mb-0",
                                                                            onConfirmPasswordChange: setConfirmPassword,
                                                                            onEmailChange: handleEmailChange,
                                                                            onFirstNameChange: setFirstName,
                                                                            onLastNameChange: setLastName,
                                                                            onPasswordChange: setPassword,
                                                                            showConfirmPasswordField: !hasAccount,
                                                                            showNameFields: !hasAccount,
                                                                            signedIn,
                                                                            textColour: theme.textColour
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                            show: !!errors && errors.length > 0,
                                                                            ignoreTheme: true,
                                                                            className: "mt-4 text-center text-red-500 text-md pb-4",
                                                                            children: [
                                                                                errors.map((e)=>typeof e.message === "string" ? "".concat(e.step, ": ").concat(e.message) : e.message),
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                            disabled: !!errors.find((f)=>f.step === tab),
                                                                            title: hasAccount ? "Sign in" : "Continue",
                                                                            className: "w-full mt-4",
                                                                            buttonType: "submit",
                                                                            loading: saving
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                            show: !!hasAccount,
                                                                            className: "flex justify-center text-sm items-center mt-2",
                                                                            children: [
                                                                                "Joining with new account?",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                    onClick: ()=>{
                                                                                        setHasAccount(false);
                                                                                        setIsNewLogin(false);
                                                                                        setErrors([]);
                                                                                    },
                                                                                    href: "#",
                                                                                    className: "underline cursor-pointer text-forumm-blue ml-2",
                                                                                    children: "Register here"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                            show: !!hasAccount,
                                                                            className: "flex justify-center text-sm items-center mt-2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: "Forgotten Password?"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    className: "flex items-center underline cursor-pointer text-forumm-blue ml-2",
                                                                                    onClick: ()=>{
                                                                                        var ref;
                                                                                        var ref1;
                                                                                        setRedirectTarget({
                                                                                            path: router.asPath,
                                                                                            analyticsIntent: "buy_ticket",
                                                                                            event: {
                                                                                                eventId: eventId,
                                                                                                title: (ref1 = event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.title) !== null && ref1 !== void 0 ? ref1 : "Event"
                                                                                            }
                                                                                        });
                                                                                        router.push("/forgot-password?previous=true");
                                                                                    },
                                                                                    children: "Reset"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tab */.O, {
                                                        title: "Register",
                                                        children: [
                                                            hasAccount === undefined && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                        className: "mb-2 text-2xl flex justify-center items-center",
                                                                        children: "Already have an account?"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                        className: "flex flex-row justify-center items-center mt-8 mb-8 flex-wrap",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                                title: "Yes",
                                                                                type: "tertiary",
                                                                                size: "auto",
                                                                                onClick: ()=>{
                                                                                    setIsNewLogin(true);
                                                                                    setHasAccount(true);
                                                                                },
                                                                                className: "whitespace-nowrap mr-1 mb-1"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                                title: "No",
                                                                                type: "tertiary",
                                                                                size: "auto",
                                                                                onClick: ()=>setHasAccount(false),
                                                                                className: "whitespace-nowrap ml-1 mb-1"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            hasAccount !== undefined && alreadyJoined && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                        className: "mb-2 text-2xl block",
                                                                        children: "Already Joined for This Event"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                        className: "text-xs pt-2 block",
                                                                        children: "You have already joined this event. If you wish, you can go back and check the event`s front page for more details."
                                                                    })
                                                                ]
                                                            }),
                                                            hasAccount !== undefined && !alreadyJoined && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                        className: "flex mb-2 justify-center items-center text-2xl",
                                                                        children: "Ticket details"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                        className: "flex mb-2 justify-center items-center text-center",
                                                                        children: "Choose your ticket and registration preferences."
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, {
                                                                        initialFormData: {
                                                                            firstName: firstName !== null && firstName !== void 0 ? firstName : "",
                                                                            lastName: lastName !== null && lastName !== void 0 ? lastName : "",
                                                                            email: (ref8 = email !== null && email !== void 0 ? email : userData) !== null && ref8 !== void 0 ? ref8 : "",
                                                                            password: password !== null && password !== void 0 ? password : "",
                                                                            confirmPassword: confirmPassword !== null && confirmPassword !== void 0 ? confirmPassword : "",
                                                                            ticketType: (ref9 = ticketData === null || ticketData === void 0 ? void 0 : ticketData.ticketName) !== null && ref9 !== void 0 ? ref9 : "",
                                                                            discountCode: (ref10 = ticketData === null || ticketData === void 0 ? void 0 : ticketData.discountCode) !== null && ref10 !== void 0 ? ref10 : "",
                                                                            attendeeList: isRegistrationVisible,
                                                                            iNeedMoreThanOneTicket: ticketData.requiresAdditional
                                                                        },
                                                                        clearForm: clearForm,
                                                                        // error={errors?.[0]?.message}
                                                                        onSubmit: ()=>continueFromTicketStep({
                                                                                onSignedIn: ()=>{
                                                                                    window.location.href = "/event/".concat(router.query.eventId, "/register");
                                                                                }
                                                                            }),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TicketDropdownInput/* TicketDropdownInput */.r, {
                                                                                tickets: availableTickets,
                                                                                ticketDetails: event === null || event === void 0 ? void 0 : event.tickets,
                                                                                currency: (ref11 = event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.currency) !== null && ref11 !== void 0 ? ref11 : "GBP",
                                                                                value: ticketData === null || ticketData === void 0 ? void 0 : (ref1 = ticketData.ticketName) === null || ref1 === void 0 ? void 0 : ref1.toUpperCase(),
                                                                                required: true,
                                                                                onChange: (val)=>{
                                                                                    setTicketData({
                                                                                        ...ticketData,
                                                                                        ticketName: val !== null && val !== void 0 ? val : ticketData === null || ticketData === void 0 ? void 0 : ticketData.ticketName,
                                                                                        discountPercentage: 0,
                                                                                        discountCode: undefined
                                                                                    });
                                                                                }
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, {
                                                                                label: "Discount Code",
                                                                                setError: errorHandler("discountCode"),
                                                                                error: (ref2 = errors.find((e)=>e.eleId === "discountCode")) === null || ref2 === void 0 ? void 0 : ref2.message,
                                                                                show: (0,register_util/* shouldShowDiscountCode */.P9)({
                                                                                    availableTickets,
                                                                                    discountPercentage: ticketData.discountPercentage,
                                                                                    ticketTotalPrice: ticketData.totalPrice
                                                                                }),
                                                                                onChange: async (val)=>{
                                                                                    setErrors((state)=>[
                                                                                            ...state.filter((f)=>f.eleId !== "discountCode")
                                                                                        ]);
                                                                                    setTicketData((state)=>({
                                                                                            ...state,
                                                                                            discountCode: val
                                                                                        }));
                                                                                },
                                                                                value: ticketData.discountCode
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxInput/* CheckboxInput */.I, {
                                                                                value: isRegistrationVisible,
                                                                                customStyles: "!justify-start pt-[8px] pb-[12px]",
                                                                                onChange: (val)=>setIsRegistrationVisible(val),
                                                                                className: "bg-transparent rounded text-sm border-box mt-2 mb-4",
                                                                                label: "Attendee List",
                                                                                // NOTE: Hilary requested to hide this on non-sussex events.
                                                                                show: (event === null || event === void 0 ? void 0 : (ref3 = event.event) === null || ref3 === void 0 ? void 0 : ref3.showAttendeeBox) || (0,register_util/* getRegistrationConfig */.rS)(register_util/* CONFIG_OPTIONS.SHOW_VISIBLE_REGISTRATION_OPT_IN */.ce.SHOW_VISIBLE_REGISTRATION_OPT_IN, event),
                                                                                isProtected: true,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "mt-2",
                                                                                    children: [
                                                                                        (event === null || event === void 0 ? void 0 : (ref4 = event.event) === null || ref4 === void 0 ? void 0 : ref4.organizationName.toLowerCase().includes("sussex")) ? "Can we add your details to the attendee list shared before the reunion?" : "Can we add your name to our public attendee list?",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                                                            className: "hidden"
                                                                                        }),
                                                                                        (event === null || event === void 0 ? void 0 : (ref5 = event.event) === null || ref5 === void 0 ? void 0 : ref5.organizationName.toLowerCase().includes("sussex")) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("small", {
                                                                                            className: "block leading-none",
                                                                                            children: [
                                                                                                "We will include your name, relationship to",
                                                                                                " ",
                                                                                                (ref12 = event === null || event === void 0 ? void 0 : (ref6 = event.event) === null || ref6 === void 0 ? void 0 : ref6.organizationName) !== null && ref12 !== void 0 ? ref12 : "the event organiser",
                                                                                                ", year of graduation and subject studied (if applicable)."
                                                                                            ]
                                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                            className: "block leading-none"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckboxInput/* CheckboxInput */.I, {
                                                                                show: selectedTicketAllowsMultiple && eventId !== "e4af5751-be4f-4a28-a17c-4e6fe64adf25" && eventId !== "fc2434df-de33-4852-b77f-12813d8191c3",
                                                                                value: ticketData.requiresAdditional,
                                                                                customStyles: "!justify-start pt-[8px] pb-[12px]",
                                                                                onChange: setRequiresAdditionalTickets,
                                                                                className: "bg-transparent rounded text-sm border-box mt-2 mb-4",
                                                                                label: "I need more than one ticket",
                                                                                isProtected: true,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: "I need more than one ticket."
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                                className: "flex flex-col",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CountInput/* CountInput */.P, {
                                                                                    className: "",
                                                                                    label: "How many additional tickets?",
                                                                                    show: ticketData.requiresAdditional && selectedTicketAllowsMultiple,
                                                                                    value: activeAdditionalTickets.length,
                                                                                    minValue: ticketData.requiresAdditional ? 1 : 0,
                                                                                    maxValue: 4,
                                                                                    onChange: (val)=>{
                                                                                        handleAdditionalTickets(val);
                                                                                    }
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                                show: !!hasAccount,
                                                                                className: "w-full text-sm flex mb-5",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: "Forgotten Password?"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        className: "flex items-center underline cursor-pointer text-forumm-blue ml-2",
                                                                                        onClick: ()=>{
                                                                                            var ref;
                                                                                            var ref1;
                                                                                            setRedirectTarget({
                                                                                                path: router.asPath,
                                                                                                analyticsIntent: "buy_ticket",
                                                                                                event: {
                                                                                                    eventId: eventId,
                                                                                                    title: (ref1 = event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.title) !== null && ref1 !== void 0 ? ref1 : "Event"
                                                                                                }
                                                                                            });
                                                                                            router.push("/forgot-password?previous=true");
                                                                                        },
                                                                                        children: "Reset"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            hasAccount && !isNewLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                className: "text-xs pt-2",
                                                                                children: "Before continuing, please make sure to carefully check the event details, including its location and scheduled time"
                                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                                show: !!errors && errors.length > 0,
                                                                                ignoreTheme: true,
                                                                                className: "mt-4 text-center text-red-500 text-md pb-4",
                                                                                children: [
                                                                                    errors.map((e)=>typeof e.message === "string" ? "".concat(e.step, ": ").concat(e.message) : e.message),
                                                                                    " ",
                                                                                    accountError ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                        onClick: ()=>{
                                                                                            setErrors([]);
                                                                                            setIsNewLogin(true);
                                                                                            setHasAccount(true);
                                                                                        },
                                                                                        href: "#",
                                                                                        className: "inline underline cursor-pointer text-md",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "!text-forumm-blue",
                                                                                            children: "Log In here"
                                                                                        })
                                                                                    }) : ""
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                                                // disabled={errors.length > 0}
                                                                                disabled: !!errors.find((f)=>f.step === tab),
                                                                                title: hasAccount && !isNewLogin ? "Confirm" : "Continue",
                                                                                className: "w-full mt-4",
                                                                                buttonType: "submit",
                                                                                loading: saving
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                                show: hasAccount,
                                                                                className: "flex flex-col justify-center items-center mt-2 space-y-3",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                                        className: "w-full text-sm flex space-x-2 justify-center",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                children: "Joining with new account?"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                                onClick: ()=>{
                                                                                                    setHasAccount(false);
                                                                                                    setIsNewLogin(false);
                                                                                                },
                                                                                                href: "#",
                                                                                                className: "underline cursor-pointer text-forumm-blue ml-2",
                                                                                                children: "Register here"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                                        className: "w-full text-sm flex space-x-2 justify-center mb-16",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                children: "Forgotten Password?"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                className: "flex items-center underline cursor-pointer text-forumm-blue ml-2",
                                                                                                onClick: ()=>{
                                                                                                    var ref;
                                                                                                    var ref1;
                                                                                                    setRedirectTarget({
                                                                                                        path: router.asPath,
                                                                                                        analyticsIntent: "buy_ticket",
                                                                                                        event: {
                                                                                                            eventId: eventId,
                                                                                                            title: (ref1 = event === null || event === void 0 ? void 0 : (ref = event.event) === null || ref === void 0 ? void 0 : ref.title) !== null && ref1 !== void 0 ? ref1 : "Event"
                                                                                                        }
                                                                                                    });
                                                                                                    router.push("/forgot-password?previous=true");
                                                                                                },
                                                                                                children: "Reset"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                                                show: !hasAccount,
                                                                                className: "flex justify-center text-sm items-center mt-2",
                                                                                children: [
                                                                                    "Already have an account?",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                        onClick: ()=>{
                                                                                            setErrors([]);
                                                                                            setIsNewLogin(true);
                                                                                            setHasAccount(true);
                                                                                        },
                                                                                        href: "#",
                                                                                        className: "underline cursor-pointer text-forumm-blue ml-2",
                                                                                        children: "Log In here"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                                                        title: "Attendee Information",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AdditionalAttendeesStep/* default */.Z, {
                                                            activeAdditionalTickets: activeAdditionalTickets,
                                                            attendeesError: attendeesError,
                                                            disableFormProgress: disableFormProgress,
                                                            errors: errors,
                                                            errorHandler: errorHandler,
                                                            getEmail: getEmail,
                                                            labelBgColour: theme.foregroundColour,
                                                            onBack: ()=>setTab("Register"),
                                                            onContinue: handleAdditionalAttendeesContinue,
                                                            onTicketChange: handleAdditionalTicketChange,
                                                            saving: saving,
                                                            setAttendeesError: setAttendeesError,
                                                            textColour: theme.textColour
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* Tab */.O, {
                                                        title: "Event Details",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RegistrationFieldsStep/* default */.Z, {
                                                            allTicketsRegistrationFieldsAreFilled: allTicketsRegistrationFieldsAreFilled,
                                                            alreadyJoined: alreadyJoined,
                                                            attendeesToGetRegFields: attendeesToGetRegFields,
                                                            event: event,
                                                            fieldVals: fieldVals,
                                                            hasAccount: hasAccount,
                                                            onBack: ()=>setTab(ticketData.requiresAdditional ? "Attendee Information" : "Register"),
                                                            onContinue: handleRegistrationFieldsContinue,
                                                            onRegistrationFieldChange: handleRegistrationFieldChange,
                                                            onRegistrationFieldNext: handleRegistrationFieldNext,
                                                            onRegistrationFieldPrevious: handleRegistrationFieldPrevious,
                                                            registrationFieldErrors: error,
                                                            regFieldSelectedAttendee: regFieldSelectedAttendee,
                                                            saving: saving,
                                                            setRegFieldSelectedAttendee: setRegFieldSelectedAttendee
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tabs/* Tab */.O, {
                                                        title: "complete",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                className: "mb-4 font-bold text-2xl text-center",
                                                                children: "Event Booked!"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                className: "mb-4 font-bold text-lg text-center",
                                                                children: "We’re delighted to have you join us for the event!"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                                className: "mb-4 text-sm text-center",
                                                                children: "An email with all the event details and instructions to join has been sent to you."
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            errors && tab !== "Register" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box["default"], {
                                                ignoreTheme: true,
                                                className: "mt-4 text-center text-red-500 text-md pb-4",
                                                children: [
                                                    errors.map((e)=>"".concat(e.step, ": ").concat(e.message)),
                                                    " ",
                                                    accountError ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        onClick: ()=>{
                                                            setErrors([]);
                                                            setIsNewLogin(true);
                                                            setHasAccount(true);
                                                        },
                                                        href: "#",
                                                        className: "inline underline cursor-pointer text-md",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "!text-forumm-blue",
                                                            children: "Log In here"
                                                        })
                                                    }) : ""
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box["default"], {
                                                className: "flex justify-center items-center mb-4 mt-4",
                                                children: tab === "complete" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/event/".concat(router.query.eventId).concat(router.query.ud ? "?ud=".concat(router.query.ud) : ""),
                                                    className: "underline cursor-pointer text-sm",
                                                    children: "View Event Now!"
                                                }) : null
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(register_EventRegistrationSummary, {
                                        event: event,
                                        foundTicket: foundTicket,
                                        isInvoiceTicket: isInvoiceTicket,
                                        invoiceTicketTotal: invoiceTicketTotal,
                                        currencySymbol: currency.symbol,
                                        ticketTotalPrice: ticketData.totalPrice,
                                        vatIncluded: vatIncluded
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
}
EventRegister.Layout = Wrapper/* UnauthenticatedWrapper */.j;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,994,1458,9198,474,4555,1209,7632,9041,5121,3913,6514,339,170,2425,3610,9774,2888,179], function() { return __webpack_exec__(27945); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);